<template>
  <div class="shadows-wrapper overflow-hidden relative scroll-smooth">
    <div
      class="scroll-container overflow-auto scrollbar-hide"
      :style="{ height }"
      ref="scrollContainer"
      @scroll.passive="toggleShadow"
    >
      <slot />
      <span
        class="shadow-bottom absolute right-0 left-0 bottom-0 h-32px opacity-0 pointer-events-none rounded-t-none rotate-180 transition-opacity bg-gradient-to-t from-linear-1 to-linear-2"
        :class="{ 'is-active': shadow.bottom }"
      />
    </div>
  </div>
</template>

<script>
function newResizeObserver(callback) {
  // Skip this feature for browsers which don't support ResizeObserver.
  // https://caniuse.com/#search=resizeobserver
  if (typeof ResizeObserver === 'undefined') return;

  return new ResizeObserver(e => e.map(callback));
}

export default {
  name: 'ScrollShadow',
  data() {
    return {
      height: undefined,
      shadow: {
        bottom: false,
      },
    };
  },
  mounted() {
    // Check if shadows are necessary after the element is resized.
    const scrollContainerObserver = newResizeObserver(this.toggleShadow);
    if (scrollContainerObserver) {
      scrollContainerObserver.observe(this.$refs.scrollContainer);
      // Cleanup when the component is destroyed.
      this.$once('hook:destroyed', () => scrollContainerObserver.disconnect());
    }

    // Recalculate the container dimensions when the wrapper is resized.
    const wrapObserver = newResizeObserver(this.calcDimensions);
    if (wrapObserver) {
      wrapObserver.observe(this.$el);
      // Cleanup when the component is destroyed.
      this.$once('hook:destroyed', () => wrapObserver.disconnect());
    }
  },
  methods: {
    async calcDimensions() {
      // Reset dimensions for correctly recalculating parent dimensions.
      this.height = undefined;
      await this.$nextTick();

      this.height = `${this.$el.clientHeight}px`;
    },
    // Check if shadows are needed.
    toggleShadow() {
      const hasVerticalScrollbar =
        this.$refs.scrollContainer.clientHeight <
        this.$refs.scrollContainer.scrollHeight;

      const scrolledFromTop =
        this.$refs.scrollContainer.offsetHeight +
        this.$refs.scrollContainer.scrollTop;

      const scrolledToBottom =
        scrolledFromTop >= this.$refs.scrollContainer.scrollHeight;

      this.shadow.bottom = hasVerticalScrollbar && !scrolledToBottom;
    },
  },
};
</script>

<style lang="scss">
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

.scrollbar-hide {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.shadows-wrapper {
  height: calc(var(--vh, 1vh) * 100 - 130px);
}

.shadow-bottom {
  background-image: linear-gradient(
    to top,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 95%
  );
}

.is-active {
  opacity: 1 !important;
}
</style>

<!-- Src: https://codesandbox.io/s/scrolling-shadows-with-vuejs-r6l5i?from-embed=&file=/src/components/ScrollShadow.vue:375-462 -->
